import cn from 'classnames';
import Link from 'next/link';
import React from 'react';

import { Button } from '@sravni/react-design-system';

import { getUrl } from '@src/utils/mapServerToClientUrls';

import styles from './styles.module.scss';

interface IProps {
  className?: string;
  to?: string;
  children?: string;
  block?: boolean;
}

export const RedirectToMoreOffersButton: React.FC<IProps> = (props) => {
  const { className, to = '/zaimy/', children = 'Смотреть все займы России', block } = props;

  return (
    <div className={cn(styles.wrapper, className)}>
      <Link href={getUrl(to)} as={to}>
        <Button className={styles.button} variant="primary" block={block}>
          {children}
        </Button>
      </Link>
    </div>
  );
};
